import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import OrderStaticsHeadquarterTable from '../../components/obtainorder_statics/OrderStaticsHeadquarterTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { makeDataPrjHeadquarterStat } from '../../utils/forecastStaticData';

const ObtainorderStaticsHqContainer = ({
  type,
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedData = makeDataPrjHeadquarterStat();
  //   console.log(JSON.stringify(loadedData));
  //   setData(loadedData);
  //   setLoading(false);
  // };

  const onLoadData = async () => {
    setLoading(true);

    const searchData = {
      startDt: selectedYear + '-' + strMonth,
      endDt: selectedYear + '-' + endMonth,
    };

    try {
      const res = await staticsApi.getOrderStaticsByHeadquarter(
        selectPrjTyp,
        searchData,
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <OrderStaticsHeadquarterTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
    />
  );

  return content;
};

export default ObtainorderStaticsHqContainer;
